import * as GETTERS from './getters';
import * as ACTIONS from './actions';
import * as MUTATIONS from './mutations';
import * as ACTIONS_SNACKBAR from '../snackbar/actions';

import storage from '@/utils/storage';
import router from '@/router';
import inewsWrapperApi from '@/api/index';

const ERROR_MESSAGES = {
  UNKNOWN_ERROR: ['Ops... Tivemos um problema no servidor.', ' Por favor, tente novamente em alguns instantes :)'],
  USER_NOT_REGISTERED: 'Usuário não encontrado. Entre em contato com algum administrador.',
};

const getters = {
  [GETTERS.isLoading]: (state) => state.isLoading,
  [GETTERS.snackbar]: (state) => state.snackbar,
  [GETTERS.isLoggedIn]: (state) => state.isLoggedIn,
};

const state = {
  currentUser: storage.get('currentUser'),
  isLoggedIn: !!storage.get('token'),
  isLoading: false,
  snackbar: true,
  errorMessage: 'Tivemos um problema ',
};

const actions = {
  [ACTIONS.getUserToken]: async ({ dispatch, commit, rootState: { pautaClient, adminClient } }, code) => {
    inewsWrapperApi
      .auth(code)
      .then(async ({ data }) => {
        storage.set('token', data.token);
        await dispatch(ACTIONS.getUserLogged);

        router.push('/');
      })
      .catch((error) => {
        switch (error?.response?.status) {
          case 400:
            dispatch(ACTIONS_SNACKBAR.showSnackbarWithMessage, {
              title: '',
              message: ERROR_MESSAGES.USER_NOT_REGISTERED,
              type: 'error',
            });
            break;
          default:
            dispatch(ACTIONS_SNACKBAR.showSnackbarWithMessage, {
              title: '',
              message: ERROR_MESSAGES.UNKNOWN_ERROR.join('\n'),
              type: 'error',
            });
            break;
        }
        router.replace('/login');
      });
  },
  [ACTIONS.logout]: ({ commit }) => {
    commit(MUTATIONS.CLEAR_CREDENTIALS);
    router.push('/login');
  },
  async [ACTIONS.getUserLogged]({ commit }) {
    const user = await inewsWrapperApi.getUserLogged();
    commit(MUTATIONS.SET_USER_LOGGED, user.data);
  },
};

const mutations = {
  [MUTATIONS.SHOW_LOADING]: (state, value) => {
    state.isLoading = value;
  },
  [MUTATIONS.SET_USER_LOGGED]: (state, userData) => {
    storage.set('currentUser', userData);
    state.isLoggedIn = true;
    state.currentUser = userData;
  },
  [MUTATIONS.CLEAR_CREDENTIALS]: (state) => {
    storage.remove('token');
    storage.remove('currentUser');
    state.currentUser = null;
    state.isLoggedIn = false;
  },
};

export default {
  getters,
  state,
  actions,
  mutations,
};
